// Ref: https://thoughtbot.com/blog/dynamic-forms-with-stimulus

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const checkedRadios = [...this.element.querySelectorAll('input[type=radio]:checked')];

    if (checkedRadios.length === 0) return;

    for (const fieldset of controlledElements(...this.element.querySelectorAll('input[type=radio]'))) {
      if (fieldset instanceof HTMLFieldSetElement) fieldset.disabled = true;
    }

    for (const radio of checkedRadios) {
      this.#activateFieldsets(radio);
    }
  }

  enable({ target }) {
    if (target.type === 'checkbox') {
      for (const fieldset of controlledElements(target)) {
        if (fieldset instanceof HTMLFieldSetElement) {
          fieldset.disabled = !target.checked;
        }
      }
      return;
    }

    const groupRadios = [...this.element.querySelectorAll(`input[type=radio][name="${target.name}"]`)];
    for (const fieldset of controlledElements(...groupRadios)) {
      if (fieldset instanceof HTMLFieldSetElement) fieldset.disabled = true;
    }

    this.#activateFieldsets(target);
  }

  #activateFieldsets(radio) {
    for (const fieldset of controlledElements(radio)) {
      if (fieldset instanceof HTMLFieldSetElement) fieldset.disabled = false;

      const selects = fieldset.querySelectorAll('select');
      for (const select of selects) {
        select.removeAttribute('disabled');

        const choicesController = select.closest('[data-controller~="choices"]')?.choices;
        if (choicesController?.choices?.disable) {
          choicesController.choices.enable();
        } else if (!choicesController?.choices) {
          choicesController?.setup?.();
        }
      }

      const inputs = fieldset.querySelectorAll('input');
      for (const input of inputs) {
        input.removeAttribute('disabled');
      }
    }
  }
}

function controlledElements(...selectedElements) {
  return selectedElements.flatMap((selectedElement) =>
    getElementsByTokens(selectedElement.getAttribute('aria-controls'))
  );
}

function getElementsByTokens(tokens) {
  const ids = (tokens ?? '').split(/\s+/);
  const elements = ids.map((id) => document.getElementById(id)).filter(Boolean);
  return elements;
}
